import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { loadStripe } from '@stripe/stripe-js'
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js'
import Loading from '../../hoc/Loading/Loading'
import axios from '../../axios'
import {
  getTrivvyPlanDetailsPlanWise,
  RECURRING_PLAN_PRICE_DATA,
} from '../trivia/data'
import { Button, Card } from 'reactstrap'
import * as url from '../../utils/url'
import { toastContainer } from '../../utils/toast'
import * as actionCreators from '../../modules/actions'
import { STRIPE_PUBLIC_KEY } from '../../utils/constants'
import { isMobile } from '../../utils/deviceInfo'

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY)

function SubscriptionPayment({ user, orgChangeSuccess, ...props }) {
  const trivvyPlanType = user.profile.organizationId.trivvyPlanType
  const [paymentSuccess, setPaymentSuccess] = useState(false)
  const [clientSecret, setClientSecret] = useState(null)
  const [apiPlans, setApiPlans] = useState([])

  const handleComplete = () => {
    return setPaymentSuccess(true)
  }

  const runAfterPayment = () => {
    setClientSecret(null)

    setPaymentSuccess(true)

    axios
      .post(url.handleStripeRecurringcheckoutForWebsitePlans, {
        plan: trivvyPlanType,
      })
      .then(({ data }) => {
        const result = data.data

        orgChangeSuccess(result)
        toastContainer('Payment done & plan activated!', 'success')

        props.history.push('/change-password')
      })
      .catch((err) => {
        toastContainer('Error while increasing response limit', 'error')
      })
  }

  useEffect(() => {
    if (paymentSuccess) {
      runAfterPayment()
    }
  }, [paymentSuccess])

  useEffect(() => {
    axios.get(url.getPaymentPlans).then(({ data }) => {
      setApiPlans(data.data)
    })
  }, [])

  const purchaseSubscriptionPlan = () => {
    const price = RECURRING_PLAN_PRICE_DATA.find(
      (x) => x.plan === trivvyPlanType
    )

    if (price) {
      axios
        .post(url.createStripeRecurringcheckoutForWebsitePlans, {
          priceId: price.priceId,
        })
        .then(({ data }) => {
          const clientSecret = data.data.clientSecret
          setClientSecret(clientSecret)
        })
        .catch((err) => {
          toastContainer('Error while processing payment', 'error')
        })
    }
  }
  if (apiPlans && apiPlans.length > 0) {
    console.log({ apiPlans })
    return (
      <div
        style={{
          width: isMobile ? '100%' : '60%',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: '10%',
          textAlign: 'center',
        }}>
        {clientSecret && !paymentSuccess ? (
          <EmbeddedCheckoutProvider
            stripe={stripePromise}
            options={{ clientSecret, onComplete: handleComplete }}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        ) : (
          <div className="text-center">
            <h4 style={{ color: '#ff3e04' }}>
              You have chosen the following plan please make payment to proceed.
            </h4>

            <div
              className="mt-5"
              style={{
                width: isMobile ? '90%' : '400px',
                margin: 'auto',
              }}>
              <Card className="mt-4 px-1 py-4 shadow">
                <b style={{ color: '#ff3e04' }}>Your plan details</b>

                <div className="mt-1">
                  <span className="large-price-text">
                    {!getTrivvyPlanDetailsPlanWise(trivvyPlanType, apiPlans)
                      .isFree &&
                      getTrivvyPlanDetailsPlanWise(trivvyPlanType, apiPlans)
                        .price}
                  </span>{' '}
                  {!getTrivvyPlanDetailsPlanWise(trivvyPlanType, apiPlans)
                    .isFree ? (
                    <span className="small-price-text">
                      {' '}
                      per month, billed annually at $
                      {getTrivvyPlanDetailsPlanWise(trivvyPlanType, apiPlans)
                        .cost * 12}
                    </span>
                  ) : (
                    <span className="small-price-text">
                      free to try, upgrade when needed
                    </span>
                  )}
                </div>
                <ul
                  className="mt-1"
                  style={{
                    paddingInlineStart: '25px',
                    listStyle: 'none',
                  }}>
                  <li>
                    Plan name:{' '}
                    <b className="ml-2">
                      {' '}
                      {
                        getTrivvyPlanDetailsPlanWise(trivvyPlanType, apiPlans)
                          .name
                      }
                    </b>
                  </li>

                  <li>
                    Responses:
                    <b className="ml-2">
                      {
                        getTrivvyPlanDetailsPlanWise(trivvyPlanType, apiPlans)
                          .responses
                      }
                    </b>
                  </li>
                  <li>
                    Seats:{' '}
                    <b className="ml-2">
                      {
                        getTrivvyPlanDetailsPlanWise(trivvyPlanType, apiPlans)
                          .seats
                      }
                    </b>
                  </li>
                  {/* <li>
                    Performance Metrics:
                    <b className="ml-2">
                      {
                        getTrivvyPlanDetailsPlanWise(trivvyPlanType)
                          .performanceMetrics
                      }
                    </b>
                  </li>
                  <li>
                    Reward Feature:
                    <b className="ml-2">
                      {getTrivvyPlanDetailsPlanWise(trivvyPlanType).rewardFeature}
                    </b>
                  </li> */}
                </ul>

                <div className="text-center">
                  <Button
                    className="trivia-action-button-main"
                    onClick={() => purchaseSubscriptionPlan()}>
                    GET STARTED
                  </Button>
                </div>
              </Card>
            </div>
          </div>
        )}
      </div>
    )
  } else {
    return <div className="my-5 py-5 text-center">Loading ...</div>
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(SubscriptionPayment, axios))
